import { Client } from '@viddsee/server-api-client';
import { baseConfiguration } from './webcall-base';

export const meApi = new Client.MeApi(baseConfiguration);
